import comp from "./AudioRecorderV2";
export default comp;
